import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptHashtags } from "../../adapters/adaptHashtags";

interface FetchParams {
	search: string;
	page: number;
	pageSize: number;
	source?: string;
}

const fetchAdminHashtagsPaged = async ({
	search,
	page,
	pageSize,
	source
}: FetchParams) => {
	const response = await cmsClient.get<CMSPaginatedData<IAdminHashtag>>(
		"/homepage/admin/hashtags/",
		{
			params: {
				search: search || undefined,
				page,
				page_size: pageSize,
				source: source || undefined
			}
		}
	);

	return response.data;
};

interface Options {
	enabled?: boolean;
}

const useAdminHashtagsPaged = (
	search: string,
	page: number,
	pageSize: number,
	source?: string,
	options: Options = {}
) => {
	const query = useQuery(
		["admin-hashtags", { search, page, pageSize, source }],
		() => fetchAdminHashtagsPaged({ search, page, pageSize, source }),
		{
			enabled: options.enabled ?? true,
			keepPreviousData: true,
			select: (data) => ({
				...data,
				results: adaptHashtags(data.results)
			})
		}
	);

	return query;
};

export default useAdminHashtagsPaged;
